module.exports = __webpack_public_path__ + "static/milliseum-d2e03a23e927505618fb7f3ba07811fb.png";